var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.421 20.36c-.4-.29-1.02-1.04-.63-2.72l.57-2.46c.05-.21-.06-.59-.21-.75l-1.99-1.99c-1.05-1.05-.96-1.96-.82-2.41.14-.45.6-1.24 2.06-1.49l2.55-.42c.19-.03.5-.26.58-.43l1.41-2.82c.68-1.36 1.58-1.56 2.06-1.56s1.38.2 2.06 1.56l1.41 2.82c.09.17.39.4.58.43l2.55.42c1.46.24 1.92 1.04 2.06 1.49.14.45.23 1.36-.82 2.41l-1.99 1.99c-.15.15-.26.54-.21.75l.57 2.46c.39 1.69-.23 2.43-.63 2.72-.4.29-1.29.66-2.79-.23l-2.39-1.42c-.2-.12-.62-.12-.82 0l-2.39 1.42c-.69.42-1.27.56-1.71.56-.5 0-.85-.17-1.06-.33zm4.86-14.82-1.41 2.82c-.3.61-1.01 1.13-1.68 1.24l-2.55.42c-.57.1-.83.31-.88.47-.05.16.04.48.45.89l1.99 1.99c.51.51.78 1.44.62 2.14l-.57 2.46c-.17.71-.06 1.09.05 1.18.11.08.51.07 1.13-.31l2.4-1.42c.67-.4 1.68-.4 2.34 0l2.39 1.42c.63.37 1.03.39 1.14.31.11-.08.22-.46.05-1.18l-.57-2.46c-.16-.71.1-1.63.62-2.14l1.99-1.99c.41-.41.5-.74.45-.89-.05-.15-.31-.37-.88-.47l-2.55-.42c-.67-.11-1.38-.63-1.68-1.24l-1.41-2.82c-.27-.54-.56-.73-.72-.73-.16 0-.45.19-.72.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 5.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75H2zM2 19.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3c.41 0 .75.34.75.75s-.34.75-.75.75H2zM2 12.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1c.41 0 .75.34.75.75s-.34.75-.75.75H2z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineStar);
export default __webpack_public_path__ + "static/media/vuesax-outline-star.f5f75aef404a02c9fa90c838eee9c6cb.svg";
export { ForwardRef as ReactComponent };